import { SET_API_URL, LOGGED_IN, LOGGED_OUT, HIDE_SPEEDTEST_INVITATION, PASSWORD_RECOVERY, RESET_RESULT } from '../constants/ActionTypes';

export function setApiUrl(url) {
    return {
        type: SET_API_URL,
        payload: url
    };
}

export function passwordRecovery(login) {
    return {
        type: PASSWORD_RECOVERY,
        payload: login
    };
}

export function loggedIn( username, session, profilePhoto ) {
    return { 
        type: LOGGED_IN, 
        payload: {
            username: username, 
            session: session, 
            profilePhoto: profilePhoto 
        }
    }
}

export function loggedOut() {
    window.FB.getLoginStatus(function(response) {
//        console.log('FB: facebook login status is ',response.status);
        if (response.status === "connected") {
            window.FB.logout(function(response) {
            });
        }
    }, true);
     
    return { 
        type: LOGGED_OUT 
    }
}
/*
export function setSession(session) {
    return { 
        type: SET_SESSION,
        payload: {
            session: session
        } 
    }
}
*/

export function hideSpeedtestInvitation() {
    return {
        type: HIDE_SPEEDTEST_INVITATION
    };
}

export function resetResult() {
    return {
        type: RESET_RESULT
    };
}